// PolariScore v1.0 — "polish-shell" para la vista politica.html v0.9.
//
// Inyecta el AppShell (Sidenav + Topbar v1) en la vista heredada sin tocar
// la lógica de gráficas (politica.module.js). Después de que Argon termina
// su init, REMOVEMOS físicamente del DOM la navbar y el aside Argon viejos
// para que el header quede 100% v1 (idéntico al de dashboard).

import { mountFooter } from "../components/Footer.js";

(async function bootstrap() {
  // Dynamic imports → Vite genera async chunks con su CSS auto-inyectado.
  const [{ mount, h }, { Sidenav }, { Topbar }, { Button },
         { whenAuthReady, loadUserProfile }] = await Promise.all([
    import("../components/dom.js"),
    import("../components/Sidenav.js"),
    import("../components/Topbar.js"),
    import("../components/Button.js"),
    import("../lib/auth.js"),
    import("../main.js"), // efectos: registra SW + carga DS CSS
  ]);

  document.body.classList.add("ps-v0-shell-on");

  const params = new URLSearchParams(window.location.search);
  const idPolitica = params.get("id");

  // Resolver user (compartido vía localStorage por ambas instancias firebase).
  let user = await whenAuthReady();
  if (user) {
    try {
      const profile = await loadUserProfile(user);
      if (profile) Object.assign(user, profile);
    } catch {}
  }

  // ── Sidenav ─────────────────────────────────────────────
  const sidenavRoot = ensureMount("ps-sidenav-mount");
  const sidenav = Sidenav({
    user,
    activeHref: "",
    activePoliticaId: idPolitica,
    open: false,
    onClose: () => sidenavRoot.classList.remove("ps-mobile-open"),
  });
  mount(sidenavRoot, sidenav);

  // ── Topbar (idéntico al de dashboard: breadcrumb + title + acciones) ──
  const topbarRoot = ensureMount("ps-topbar-mount");
  const titleEl = document.getElementById("titulo_politica");
  const initialTitle = (titleEl?.textContent || "").trim();

  const refrescarBtn = Button({
    variant: "ghost", size: "sm",
    icon: h("i", { class: "fa-solid fa-rotate" }),
    onClick: () => window.location.reload(),
    children: "Refrescar",
  });

  const topbar = Topbar({
    title: initialTitle && initialTitle !== "Cargando..." ? initialTitle : "Detalle de política",
    breadcrumb: [
      { label: "PolariScore", href: "/" },
      { label: "Políticas",   href: "/politicas" },
      { label: idPolitica || "Detalle" },
    ],
    user,
    actions: [refrescarBtn],
    onMenu: () => sidenavRoot.classList.add("ps-mobile-open"),
  });
  mount(topbarRoot, topbar);

  // Refrescar el título cuando la v0.9 termina de cargar.
  if (titleEl) {
    const observer = new MutationObserver(() => {
      const t = (titleEl.textContent || "").trim();
      if (!t || t === "Cargando...") return;
      const h1 = topbarRoot.querySelector("h1");
      if (h1 && h1.textContent !== t) h1.textContent = t;
    });
    observer.observe(titleEl, { childList: true, characterData: true, subtree: true });
  }

  // ── Footer común ───────────────────────────────────────
  // Solo reemplazo si EXISTE el footer original. Si no, NO toco body
  // (importante: con `replace:true` apuntando a body sustituiría todo).
  const oldFooter = document.querySelector("footer.footer");
  if (oldFooter) mountFooter({ container: oldFooter, replace: true });

  // ── Ocultar el chrome Argon (sin removerlo del DOM) ────
  // CRÍTICO: politica.module.js v0.9 referencia IDs dentro del aside Argon
  //   (#cargarPoliticas, #anteriorBtn, #siguienteBtn, etc.). Si removemos
  //   esos nodos, el módulo crashea con TypeError de null. Los mantenemos en
  //   el DOM pero offscreen via la clase body.ps-v0-shell-on en polish.css.
  // (No-op aquí; la clase ya se aplicó arriba.)

  function ensureMount(id) {
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("div");
      el.id = id;
      document.body.appendChild(el);
    }
    return el;
  }
})();
